<template>
    <div id="frm_booking" v-if="api && booking.pos_id && booking.pos_parent">
        <form action="" method="post" class="frm_booking" @submit.prevent="booking_online" v-if="stepActive==='1'">
            <div class="form-group">
                <label>Nhà hàng</label>
                <input type="text" class="form-control" value="Hương Mai - 264 Hoàng Văn Thái" readonly>
            </div>
            <div class="form-group">
                <label>Tên khách hàng</label>
                <input type="text" class="form-control" name="username" v-model="booking.username" autocomplete="off">
            </div>
            <div class="form-group one-half">
                <label>Số điện thoại</label>
                <input type="text" class="form-control" name="user_id" v-model="booking.user_id" @change="formatNumberPhone"  v-mask="'###########'" autocomplete="off">
            </div>
            <div class="form-group one-half">
                <label>Số khách</label>
                <input type="number" value="1" min="1" class="form-control" name="Number_People" v-model="booking.booking_info.Number_People" autocomplete="off">
            </div>
            <div class="form-group one-half datepicker">
                <label>Ngày</label>
                <datetime type="date" format="yyyy-MM-dd" class="form-control" name="Book_Date" v-model="booking.booking_info.Book_Date" autocomplete="off"></datetime>
            </div>
            <div class="form-group one-half timepicker">
                <label>Giờ</label>
                <datetime type="time" class="form-control" name="Book_Hour" v-model="bookingtime" autocomplete="off"></datetime>
            </div>
            <div class="form-group">
                <label>Ghi chú</label>
                <textarea class="form-control" rows="3" v-model="booking.booking_info.Note"></textarea>
            </div>
            <div class="form-group">
                <button type="submit" class="btn" v-bind:class="{'loading':loading}">Xác nhận đặt bàn</button>
            </div>
        </form>
        <div class="message" v-if="stepActive==='2'" style="text-align: center;">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Booking',
        props:{
            stepActive: {
                type: String,
                default: "1"
            }
        },
        data () {
            return {
                api: this.$foodbookConfig.wpapi, //Api url
                booking: {
                    pos_id: this.$foodbookConfig.pos_id || 0,
                    pos_parent:this.$foodbookConfig.pos_name,
                    user_id: null,
                    username: null ,
                    booking_info: {
                        Book_Date: null,
                        Hour: null,
                        Minute: null,
                        Number_People: null,
                        Note: null
                    }
                },
                bookingtime: '',
                loading: false,
                validates: false,
            }
        },
        created(){

        },
        mounted() {
            let ref = document.referrer;
            if(this.stepActive === '2' && !ref){
                window.location.replace(this.$foodbookConfig.homepage);
            }
        },
        watch: {
            bookingtime: function (val) {
                let $today = new Date(val);
                $today = $today.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
                let minute = $today.split(':')[1];
                this.booking.booking_info.Minute = minute.split(' ')[0];
                this.booking.booking_info.Hour = $today.split(':')[0];

            },
        },
        methods: {
            nextStep() {
                this.stepActive = parseInt(this.stepActive) + 1;
            },
            formatNumberPhone() {
                if (!this.booking.user_id) return false;
                let firstChar = this.booking.user_id.substring(0, 1);
                //console.log(firstChar);
                if (firstChar === '0') {
                    this.booking.user_id = '84' + this.booking.user_id.substring(1)
                }
            },
            booking_online: function(event) {
                if (this.booking.username
                    && this.booking.user_id
                    && this.booking.booking_info.Book_Date
                    && this.booking.booking_info.Number_People
                    && this.booking.booking_info.Minute
                    && this.booking.booking_info.Hour) {
                    //Check format
                    if (this.booking.user_id.length < 11) {
                        this.validates = true;
                        this.$toasted.show("Số điện thoại phải hơn 10 số", {
                            position: "top-center",
                            duration: 5000,
                            type: 'error'
                        });
                        return;
                    }
                    if (this.booking.user_id.substring(0, 2) !== '84') {
                        this.validates = true;
                        this.$toasted.show("Số điện thoại không đúng (84xxxxxxx)", {
                            position: "top-center",
                            duration: 5000,
                            type: 'error'
                        });
                        return;
                    }
                    //Tạo đơn đặt bàn

                    this.loading = true;
                    let $date = new Date(this.booking.booking_info.Book_Date);
                    let dateY = $date.getFullYear();
                    let dateM = ("0" + ($date.getMonth() + 1)).slice(-2);
                    let dateD = ("0" + $date.getDate()).slice(-2);
                    this.booking.booking_info.Book_Date = dateY + '-' + dateM + '-' + dateD + ' 00:00:00';

                    this.$http.post(this.api + '/booking', this.booking, {method: 'POST'}).then(response => {
                        this.loading = false;
                        if (!response) {
                            this.$toasted.show("Hệ thống chưa xử lý được. Vui lòng thử lại sau..", {
                                position: "top-center",
                                duration: 5000,
                                type: 'error'
                            });
                        } else {
                            if (!response.body.error) {
                                this.$toasted.show("Đăng ký đặt bàn thành công!", {
                                    position: "top-center",
                                    duration: 5000,
                                    type: 'success'
                                });
                                //this.nextStep();
                                window.location.href = this.$foodbookConfig.bookingpage;
                            } else {
                                //this.$toasted.show(response.body.error.message, {
                                this.$toasted.show("Hệ thống chưa xử lý được. Vui lòng thử lại sau..", {
                                    position: "top-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                            }
                        }
                    }, response => {
                        this.$toasted.show("Hệ thống chưa xử lý được. Vui lòng thử lại sau..", {
                            position: "top-center",
                            duration: 5000,
                            type: 'error'
                        });
                        this.loading = false;
                    });
                    this.validates = false;
                } else {
                    this.validates = true;
                    this.$toasted.show("Vui lòng điền đầy đủ thông tin", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Booking.vue